const profile = {
  title: "ملفي الشخصي",
  premiumBtn: "اذهب للحساب المميز",
  orderInfoTitle: "معلومات ترخيص الحساب",
  tableStatus: "المنتج",
  tableProduct: "الحالة",
  tablePermissionDate: "تاريخ الترخيص",
  tableValidPeriod: "فترة الصلاحية",
  validStauts: "صالح",
  expiredStauts: "انتهت الصلاحية",
  noData: "لا توجد بيانات",
};

export default profile;
